module.exports = __webpack_public_path__ + "img/icon_h-pharmacy.769b397e.png";